export const InputTypes = {
  POINT: "point",
  SEGMENT: "segment"
}
